import * as React from "react";

interface RedditIconProps {
	iconColor: string;
	style: any;
	onClick?: () => void;
}

const RedditIcon = (props: RedditIconProps) => (
	<svg
		width="38px"
		height="38px"
		viewBox="0 0 45 45"
		version="1.1"
		style={props.style}
		onClick={props.onClick}
	>
		<g
			id="1440x-1024"
			stroke="none"
			strokeWidth="1"
			fill="none"
			fillRule="evenodd"
			transform="translate(-877.000000, -922.000000)"
		>
			<g
				id="Social-Media-Icons"
				transform="translate(518.000000, 922.000000)"
				fill={props.iconColor}
				fillRule="nonzero"
			>
				<g id="006-reddit-social-logo-character" transform="translate(359.331695, 0.000000)">
					<path
						d="M11.439644,19.9927127 C10.9943283,19.6435707 10.4460021,19.4425633 9.87534172,19.4425633 C8.47603871,19.4425633 7.33836434,20.5820609 7.33836434,21.9822755 C7.33836434,22.7935978 7.7298957,23.5420198 8.36573535,24.0128602 C8.89355062,22.5023422 9.96422253,21.1303871 11.439644,19.9927127 Z"
						id="Shape"
					/>
					<path
						d="M33.1584676,13.7272993 C34.2036148,13.7272993 35.05368,12.8763225 35.05368,11.8302638 C35.05368,10.784205 34.2036148,9.9341398 33.1584676,9.9341398 C32.1124089,9.9341398 31.2605205,10.784205 31.2605205,11.8302638 C31.2605205,12.8763225 32.1124089,13.7272993 33.1584676,13.7272993 Z"
						id="Shape"
					/>
					<path
						d="M22.2771775,0 C9.97425011,0 0,9.97425011 0,22.2771775 C0,34.5801048 9.97425011,44.5543549 22.2771775,44.5543549 C34.5801048,44.5543549 44.5543549,34.5801048 44.5543549,22.2771775 C44.5543549,9.97425011 34.5801048,0 22.2771775,0 Z M36.3404006,25.0839879 C36.4001103,25.4349531 36.4383974,25.7900206 36.4383974,26.1523808 C36.4383974,31.3662659 30.0562995,35.6074758 22.2110866,35.6074758 C14.3663295,35.6074758 7.98514316,31.3662659 7.98514316,26.1523808 C7.98514316,25.7676864 8.02981146,25.3911964 8.09726972,25.0192644 C7.0270536,24.3916291 6.35064785,23.242104 6.35064785,21.9827313 C6.35064785,20.037381 7.93181467,18.4562142 9.87579752,18.4562142 C10.7641498,18.4562142 11.6101128,18.8094585 12.2591706,19.4079226 C14.7688001,17.7716041 18.1836464,16.7515258 21.9531043,16.7059459 L24.1477767,9.76458256 C24.2261741,9.51708369 24.4823331,9.3721396 24.7325668,9.43230507 L30.4774578,10.7846608 C30.8977045,9.71170987 31.9378378,8.9473349 33.1589234,8.9473349 C34.7482946,8.9473349 36.0423081,10.2408925 36.0423081,11.8307196 C36.0423081,13.4205466 34.7482946,14.7150158 33.1589234,14.7150158 C31.5681848,14.7150158 30.2746272,13.4205466 30.2746272,11.8307196 C30.2746272,11.8038274 30.2814642,11.7801259 30.2823758,11.7532337 L24.9527177,10.4979632 L22.9836659,16.7232663 C26.5881247,16.8522574 29.8438971,17.8664103 32.248237,19.4580605 C32.9018528,18.8267788 33.756476,18.4557584 34.6785574,18.4557584 C36.622996,18.4557584 38.2055303,20.0378368 38.2055303,21.9827313 C38.2041629,23.3018137 37.4821772,24.4750404 36.3404006,25.0839879 Z"
						id="Shape"
					/>
					<path
						d="M15.3440185,24.4030241 C15.3440185,23.2457504 16.2856992,22.3040696 17.442973,22.3040696 C18.6002467,22.3040696 19.5414717,23.2457504 19.5414717,24.4030241 C19.5414717,25.5602978 18.6007025,26.5015228 17.442973,26.5015228 C16.2852434,26.5015228 15.3440185,25.5602978 15.3440185,24.4030241 Z M27.3693642,30.6255924 C26.3119104,31.6839578 24.6514346,32.1976433 22.294042,32.1976433 C22.2885724,32.1976433 22.2835586,32.1935411 22.2771775,32.1935411 C22.2707963,32.1935411 22.2657825,32.1976433 22.2594013,32.1976433 C19.9020087,32.1976433 18.2419887,31.6839578 17.1840791,30.6255924 C16.9917319,30.4332452 16.9917319,30.1210229 17.1840791,29.9277641 C17.3773379,29.7354169 17.6895602,29.7354169 17.882819,29.9277641 C18.7456466,30.7915033 20.1768555,31.2103826 22.2594013,31.2103826 C22.2657825,31.2103826 22.2707963,31.214029 22.2771775,31.214029 C22.2835586,31.214029 22.2885724,31.2103826 22.294042,31.2103826 C24.3770436,31.2103826 25.8087083,30.7910475 26.6715359,29.9277641 C26.8647947,29.7354169 27.177017,29.7354169 27.3702758,29.9277641 C27.562623,30.1210229 27.562623,30.433701 27.3693642,30.6255924 Z M27.1191305,26.5015228 C25.9627684,26.5015228 25.0206318,25.5612094 25.0206318,24.4030241 C25.0206318,23.2448388 25.9618568,22.3040696 27.1191305,22.3040696 C28.2764043,22.3040696 29.2176292,23.2457504 29.2176292,24.4030241 C29.2176292,25.5602978 28.2764043,26.5015228 27.1191305,26.5015228 Z"
						id="Shape"
					/>
					<path
						d="M34.67719,19.4425633 C34.0718889,19.4425633 33.5039633,19.660891 33.0499875,20.0410274 C34.5162929,21.1878178 35.5746583,22.5688888 36.085609,24.0876112 C36.7834373,23.623152 37.2159906,22.8469262 37.2159906,21.9822755 C37.2159906,20.5820609 36.0783162,19.4425633 34.67719,19.4425633 Z"
						id="Shape"
					/>
				</g>
			</g>
		</g>
	</svg>
);

export default RedditIcon;



// WEBPACK FOOTER //
// ./src/components/Footer/RedditIcon.tsx